<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
    class="m-edition-section-content-subject"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyShopping"
    class="m-edition-section-content-subject"
  >
    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row m-simple-filter"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomSelectPrimary
          v-model.number="simpleFilter.freeShopps"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.typesOfShopp"
          keyField="id"
          name="shoppType"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />
        <AtomSelectPrimary
          v-model.number="simpleFilter.estado"
          :disabled="simpleFilter.freeShopps || pagination.showLoadingState"
          :elements="$filters.parameters.salesStates"
          keyField="id"
          name="estado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model.number="simpleFilter.periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionBillingMyPaymentsDropDownFilters
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>
    </div>

    <div class="m-table-primary">
      <table
        v-show="compras.length"
        class="table-layout-fixed"
      >
        <tr v-show="compras.length">
          <th
            class="text-align-right"
            width="16%"
          >
            {{ $t('mEditionBillingMyShopping.table.thTotal') }}
          </th>
          <th
            class="text-align-center"
            width="15%"
          >
            {{ $t('mEditionBillingMyShopping.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingMyShopping.table.thDiscount') }}
          </th>
          <th
            class="text-align-center"
            width="17%"
          >
            {{ $t('mEditionBillingMyShopping.table.thMethod') }}
          </th>
          <th
            class="text-align-left"
            width="17%"
          >
            {{ $t('mEditionBillingMyShopping.table.thDetail') }}
          </th>
          <th
            class="text-align-center"
            width="14%"
          >
            {{ $t('mEditionBillingMyShopping.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="9%"
          >
            {{ $t('mEditionBillingMyShopping.table.thRecord') }}
          </th>
        </tr>

        <tr
          v-for="(compra, index) in compras"
          :key="index"
          class="row-data"
        >
          <td class="text-align-right text-white-space-nowrap">
            <a
              v-if="compra.total || compra.precio"
              class="sale-state"
              href="#"
              @click.prevent="gotToShoppRecord(compra)"
            >
              <span>{{ compra.divisa }} {{ compra.total.toFixed(2) }}</span>
              <span class="text-color-black-35"> {{ compra.divisa_iso_code }}</span><br>
              <small :class="$filters.getSaleStateValue(compra.compra_estado, 'class')">
                {{ $filters.getSaleStateValue(compra.compra_estado, 'name') }}
              </small>
            </a>
            <a
              v-else
              class="sale-state"
              href="#"
              @click.prevent="gotToShoppRecord(compra)"
            >
              <span>{{ $t('mEditionBillingMyShopping.free') }}</span><br>
              <small :class="$filters.getSaleStateValue(compra.compra_estado, 'class')">
                {{ $filters.getSaleStateValue(compra.compra_estado, 'name') }}
              </small>
            </a>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(compra.fecha_compra).format('D MMM YYYY') }}
          </td>
          <td class="text-align-center">
            <span v-if="compra.cupon_codigo" >
              {{ compra.cupon_codigo }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="text-align-center">
            <span v-if="compra.medio_pago">
              {{ compra.medio_pago }}
            </span>
            <span v-else >
              -
            </span>
          </td>

          <td class="break-word text-align-left">
            {{ compra.concepto }}
          </td>
          <td class="text-align-center">
            {{
              compra.total || compra.precio
                ? getPagoFrequency(compra.pago_cuotas, compra.pago_frecuencia, compra.pago_intervalo)
                : '-'
            }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.record"
              :element="compra"
              @gotToShoppRecord="gotToShoppRecord"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyShopping',

  components: {
    MoleculeEditionBillingMyPaymentsDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingMyShoppingDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        record: {
          class: 'a-button-no-border a-button-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToShoppRecord',
          tooltip: this.$t('mEditionBillingMyShopping.tooltips.shopping'),
          type: 'button'
        }
      },

      buttonSecondary: {
        filter: {
          class: 'a-button-secondary a-button-side',
          component: 'MoleculeEditionBillingMyPaymentsDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingMyShopping.buttonSecondary.filterText'),
          type: 'button'
        },

        reset: {
          class: 'a-button-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingMyShopping.tooltips.restart'),
          type: 'button'
        }
      },

      compras: [],

      filter: {
        estado: [],
        divisa: [],
        pasarela_pago: [],
        fecha_desde: '',
        fecha_hasta: '',
        free_shopp: '',
        cupon: '',
        pagina: 1,
        limite: 10
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      showLoadingState: 0,

      simpleFilter: {
        estado: '',
        freeShopps: 0,
        periodo: 0
      }
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    }
  },

  created () {
    if (this.academyDataColor) {
      this.buttonIconRounded.record.class = `${this.buttonIconRounded.record.class} a-button-academy-secondary`
      this.buttonSecondary.filter.class = `${this.buttonSecondary.filter.class} a-button-academy-secondary`
      this.buttonSecondary.reset.class = `${this.buttonSecondary.filter.class} a-button-academy-secondary`
    } else {
      this.buttonIconRounded.record.class = `${this.buttonIconRounded.record.class} a-button-billing-secondary`
      this.buttonSecondary.filter.class = `${this.buttonSecondary.filter.class} a-button-billing-secondary`
      this.buttonSecondary.reset.class = `${this.buttonSecondary.filter.class} a-button-billing-secondary`
    }
    this.searchSimpleFilter()
  },

  methods: {
    getPagoFrequency (cuotas, frecuencia, intervalo) {
      return cuotas > 1
        ? `${cuotas} cuotas`
        : frecuencia === 0
          ? 'Contado'
          : `1 pago cada ${intervalo} ${this.$filters.getFrequencyValue(frecuencia, 'name')}`
    },

    getTotalVenta (total, monto, trial, cuotas) {
      if (!total && monto) {
        total = monto
      }
      return !cuotas
        ? total
        : (cuotas * monto) + trial
    },

    gotToShoppRecord (compra) {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myShopping.subject')}/${compra.id_compra}/${this.$t('mEditionMenu.billing.myShopping.children.record.subedition')}`)
    },

    readVentasComprasAlumno () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('ventas', 'readComprasAlumno', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            this.compras = response.data.compras
            this.pagination.currentQuantity = this.compras.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState++
          })
          .catch(error => {
            console.log(error)
            this.compras = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState++
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        estado: [],
        divisa: [],
        pasarela_pago: [],
        fecha_desde: '',
        fecha_hasta: '',
        free_shopp: 0,
        cupon: '',
        pagina: 1,
        limite: 10
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        estado: '',
        freeShopps: this.filter.free_shopp || 0,
        periodo: 0
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.filter = Object.assign({}, advancedFilter)
      this.resetSimpleFilter()
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      this.resetAdvancedFilter()

      if (this.simpleFilter.estado !== '') {
        this.filter.estado[0] = this.simpleFilter.estado
      }

      if (this.simpleFilter.freeShopps === '') {
        this.simpleFilter.freeShopps = 0
      }

      if (this.simpleFilter.periodo === '') {
        this.simpleFilter.periodo = 0
      }

      this.filter.fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom
      this.filter.fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo
      this.filter.free_shopp = this.simpleFilter.freeShopps
      this.setPaginationCurrentPage(1)
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readVentasComprasAlumno()
    }
  }
}
</script>
